import styled, { css } from 'styled-components/macro';
import { staffCardGridStyles } from '../../common/elements/Staff';
import { iconButtonStyles } from '../../common/elements/Button';
import {
  fontSize,
  fontWeight,
  media,
  neutral,
  radius,
  shadow,
  space,
} from '../../../theme/tokens';
import { DeleteButton as FormDeleteButton } from '../../common/elements/Form';
import { AlignButton } from '../../common/elements/Staff';

// header row: classroom name plus its action buttons, wrapping instead of stacking
export const Inline = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[2]};
  min-width: 0;

  ${AlignButton} {
    margin: 0;
  }
`;

export const DeleteModuleButton = styled(FormDeleteButton).attrs(
  ({ isEditing }) => ({
    $variant: isEditing ? 'secondary' : 'dangerSecondary',
  })
)``;

export const CardList = styled.ul`
  ${staffCardGridStyles}

  ${({ pageBreak }) =>
    pageBreak &&
    css`
      border-bottom: 1px solid ${neutral.border};
      padding-bottom: ${space[5]};
      margin-bottom: ${space[4]};
    `}
`;

export const TopicsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space[5]};
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const EditClassroomButton = styled.button`
  ${iconButtonStyles}
`;

export const ClassroomHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]} ${space[4]};
`;

export const ClassroomTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[1]};
  min-width: 0;
`;

export const ClassroomActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${space[2]};
`;

export const ClassroomIconButton = styled.button`
  ${iconButtonStyles}
`;

// the classroom-wide settings, grouped in one card
export const ClassroomSettings = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${space[5]};
  padding: ${space[4]};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.lg};
  background: ${neutral.surface};
  box-shadow: ${shadow.sm};

  ${media.md`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}
`;

export const SettingsField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space[3]};
  min-width: 0;

  & .MuiFormControl-root,
  & .MuiAutocomplete-root {
    width: 100%;
    margin: 0;
  }
`;

export const SettingsLabel = styled.h2`
  margin: 0;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.bold};
  color: ${({ theme }) => theme.headerColour};
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
